<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end" *ngIf="data.confirmation">
  <button type="button" mat-raised-button color="primary" (click)="confirm()">Yes</button>
  <button type="button" mat-raised-button color="warn" (click)="cancel()">No</button>
</div>

<div mat-dialog-actions align="end" *ngIf="!data.confirmation">
  <button class="p-6" type="button" mat-button color="warn" (click)="cancel()">Ok</button>
</div>
